export const environment = {
  apiBaseUrl: 'https://nest-api-dev.tacitapp.com/api-v3',
  baseUrl: 'https://nichepharma-products.fra1.cdn.digitaloceanspaces.com/',
  leaveManagementCdn: 'https://nichepharma-leave-management.fra1.cdn.digitaloceanspaces.com',
  ticketCdnUrl: 'https://nichepharma-tickets-v2.fra1.cdn.digitaloceanspaces.com/',
  salesSheetsCdnUrl:
    'https://nichepharma-sales-sheets-v2.fra1.cdn.digitaloceanspaces.com/',
};
